export enum PATH {
    SIGN_IN = '/',

    PAYMENTS = '/payments',
    PAYMENT = '/payment',

    COMPLAINTS = '/complaints',
    COMPLAINT = '/complaint',

    ACCOUNTS = '/accounts',
    ACCOUNT = '/account',

    ACCOUNT_DRAFTS = '/account_drafts',

    ACCOUNT_POOLS = '/account_pools',
    ACCOUNT_POOL = '/account_pool',

    AGENTS = '/agents',
    AGENT = '/agent',

    PAYMENT_METHODS = '/payment_methods',
    PAYMENT_METHOD = '/payment_method',

    MERCHANTS = '/merchants',
    MERCHANT = '/merchant',
    MERCHANT_POOLS = '/merchant_pools',

    TRANSACTIONS = '/transactions',

    PROXIES = '/proxies',
    PROXY = '/proxy',

    AUTO_PARSER_MANAGERS = '/auto_parser_managers',

    STATISTICS_AGENT = '/statistics/agent',

    USERS = '/users',
    USER = '/user',

    ADMIN_PANEL = '/admin',
    ADMIN_ACCOUNT_CONVERSION_SETTING = '/admin/account-conversion-setting',
    ADMIN_PREPAY_SETTING = '/admin/prepay-setting',
    ADMIN_ANTI_FRAUD_SETTING = '/admin/anti-fraud-setting',
    ADMIN_BLACK_LIST_SETTING = '/admin/black-list',

    SETTINGS = '/settings',
}
